import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-own-mark',
  templateUrl: './own-mark.component.html',
  styleUrls: ['./own-mark.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class OwnMarkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
